import i18n from '../../../i18n'

export const getLabels = (): string[] => {
  const labels: string[] = []
  for (let i = 0; i < 12; i++) {
    labels.push(i18n.t(`monthsShort.${i}`, { ns: 'strDates' }))
  }
  return labels
}

export const getData = (data, property) => {
  let newData = Array(12).fill(0)
  data.forEach(d => {
    newData[d.month - 1] += d[property]
  })
  return newData
}
